import React from 'react';

export interface WhatsAppTemplate {
  id: string;
  name: string;
  description: string;
  content: string;
  thumbnail: string;
}

export const whatsAppTemplates: WhatsAppTemplate[] = [
  {
    id: 'welcome',
    name: 'Welcome Message',
    description: 'Welcome new customers to your business',
    thumbnail: '👋',
    content: "Hello {{firstName}} 👋\n\nWelcome to {{businessName}}! We're excited to have you join us.\n\nFeel free to message us here if you have any questions or need assistance.\n\nThank you for choosing us!\n\nThe {{businessName}} Team"
  },
  {
    id: 'update',
    name: 'Order Update',
    description: 'Send updates about customer orders',
    thumbnail: '📦',
    content: "Hi {{firstName}} 👋\n\n*Order Update*\n\nYour order #[[orderNumber]] has been [[status]]. [[additionalInfo]]\n\nTrack your order here: [[trackingLink]]\n\nIf you have any questions, reply to this message and we'll assist you.\n\nThank you,\n{{businessName}} Team"
  },
  {
    id: 'feedback',
    name: 'Feedback Request',
    description: 'Request feedback from customers',
    thumbnail: '⭐',
    content: "Hello {{firstName}} 👋\n\nThank you for your recent experience with {{businessName}}. We hope you enjoyed our service!\n\nWe'd love to hear your feedback. How was your experience with us?\n\nSimply reply to this message with your thoughts or click the link below to leave a review:\n\n[[reviewLink]]\n\nYour feedback helps us improve!\n\nBest regards,\n{{businessName}} Team"
  }
];

const WhatsAppTemplates = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {whatsAppTemplates.map((template) => (
        <div key={template.id} className="border rounded-lg p-4 hover:border-primary cursor-pointer">
          <div className="text-4xl mb-2">{template.thumbnail}</div>
          <h3 className="font-medium">{template.name}</h3>
          <p className="text-sm text-muted-foreground">{template.description}</p>
        </div>
      ))}
    </div>
  );
};

export default WhatsAppTemplates; 